import angular from 'angular';
import { find } from 'lodash';
import parseUrlParams from 'common/helpers/parse-url-params';

module.exports = angular.module('common.directives.pager', [])
.directive('ocPager', function() {
  function changePage(toPage) {
    var link = find(this.paginator.links, { rel: toPage });
    var params = parseUrlParams(link.href);

    this.paginator.page = params.page;
    if (this.onPage) {
      this.onPage(params, link);
    } else {
      this.paginator['$' + toPage]();
    }
  }

  return {
    restrict: 'C',
    scope: {
      paginator: '=',
      onPage: '=?'
    },
    template: require('./pager.jade')(),
    link: function(scope) {
      scope.changePage = changePage;
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/pager.js
 **/